import { render, staticRenderFns } from "./SelectTopic.vue?vue&type=template&id=2bcabe00&"
import script from "./SelectTopic.vue?vue&type=script&lang=js&"
export * from "./SelectTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports